
import React from 'react';
import { motion } from 'motion/react';
import { Construction, Clock, Home, GraduationCap } from 'lucide-react';

interface MaintenanceViewProps {
  message?: string;
  onRetry?: () => void;
}

const MaintenanceView: React.FC<MaintenanceViewProps> = ({ message, onRetry }) => {
  return (
    <div className="min-h-[80vh] flex items-center justify-center p-6">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full bg-white dark:bg-slate-900 rounded-[3rem] p-10 shadow-2xl border border-slate-100 dark:border-slate-800 text-center relative overflow-hidden"
      >
        {/* Abstract Background Decoration */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-amber-500/10 dark:bg-amber-500/20 rounded-full -mr-16 -mt-16 blur-3xl" />
        <div className="absolute bottom-0 left-0 w-32 h-32 bg-indigo-500/10 dark:bg-indigo-500/20 rounded-full -ml-16 -mb-16 blur-3xl" />

        <motion.div
          animate={{ 
            rotate: [0, 360],
            scale: [1, 1.2, 1],
            y: [0, -10, 0]
          }}
          transition={{ 
            rotate: { duration: 4, repeat: Infinity, ease: "linear" },
            scale: { duration: 2, repeat: Infinity, ease: "easeInOut" },
            y: { duration: 1.5, repeat: Infinity, ease: "easeInOut" }
          }}
          className="text-8-xl mb-6 block drop-shadow-xl"
        >
          <span className="text-8xl inline-block">😵‍💫</span>
        </motion.div>

        <motion.div
          animate={{ rotate: [0, 10, -10, 0] }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
          className="inline-flex p-5 bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 rounded-3xl mb-8 relative z-10"
        >
          <Construction size={48} />
        </motion.div>

        <h1 className="text-3xl font-black text-slate-900 dark:text-white mb-4 tracking-tight leading-tight">
          {message ? (
            <>
              Agenda Nesaka Maintenance !<br />
              <span className="text-xl font-bold block mt-2 opacity-80">cek lagi Pukul 14:00</span>
            </>
          ) : 'Website Sedang Maintenance'}
        </h1>
        
        <p className="text-slate-500 dark:text-slate-400 font-medium mb-8 leading-relaxed whitespace-pre-line">
          {message ? (
            <>
              Admin sedang mencari bug/error nya heula<br />
              hampura, aduh rieut (&gt;.&lt;)!
            </>
          ) : 'Kami sedang melakukan pembaruan sistem untuk memberikan pengalaman belajar yang lebih baik. Silakan cek kembali beberapa saat lagi.'}
        </p>

        <div className="flex flex-col gap-3 relative z-10">
          {onRetry ? (
            <button 
              onClick={onRetry}
              className="flex items-center justify-center gap-2 py-4 px-6 bg-indigo-600 hover:bg-indigo-700 text-white rounded-2xl shadow-lg shadow-indigo-200 dark:shadow-none transition-all active:scale-95 font-bold"
            >
              <Clock size={16} />
              <span>Refresh</span>
            </button>
          ) : (
            <div className="flex items-center justify-center gap-2 py-3 px-4 bg-slate-50 dark:bg-slate-800/50 rounded-2xl border border-slate-100 dark:border-slate-700/50 text-slate-600 dark:text-slate-400 text-sm font-black uppercase tracking-widest">
              <Clock size={16} />
              <span>Akan segera kembali</span>
            </div>
          )}
        </div>

        <div className="mt-10 flex items-center justify-center gap-2 text-[10px] font-black text-slate-300 dark:text-slate-600 uppercase tracking-[0.2em]">
          <GraduationCap size={14} />
          <span>SMPN 1 KAWALI DIGITAL</span>
        </div>
      </motion.div>
    </div>
  );
};

export default MaintenanceView;
